import axiosSetup from "../utils/axiosSetup";

export const handleLoginApi = async (
  email: string,
  username: string,
  password: string,
) => {
  const { data } = await axiosSetup.post("/login", {
    email,
    username,
    password,
  });
  return { token: data.data, role: data.user.role, user: data.user };
};

export const handleOtpLoginApi = async (mobileNumber: string, otp: string) => {
  const { data } = await axiosSetup.post("/verify-otp", {
    mobileNumber,
    otp,
  });
  return { token: data.data, role: data.user.role, user: data.user };
};

export const handleSendOtpApi = async (mobileNumber: string) => {
  const { data } = await axiosSetup.post("/login-otp", {
    mobileNumber,
  });
  return { message: data.data };
};
